import React, {Component} from 'react';

import {LogoSvg} from '../svgs';

import {SearchForm, StickyMenu} from './elements';

const jQuery = window.jQuery,
	$ = jQuery;

class Header extends Component {

	constructor(props) {
		super(props);

		const {api: {getHeader}} = props;
		this.state = getHeader();
	}

	componentDidMount() {
		$(".primary-nav .button-collapse").sideNav();

		$(".submenu-init").dropdown({
			inDuration     : 300,
			outDuration    : 225,
			constrain_width: true,
			hover          : false,
			alignment      : 'right',
			gutter         : 0,
			belowOrigin    : true
		});
	}

	render() {
		const {currentLanguage, setActiveLanguage, translate, ...props} = this.props;
		const {languages} = this.state;
		return (
			<header id="navigation" className="root-sec header-area nav">
				<div className="container">
					<div className="row">
						<div className="col s12">
							<div className="nav-inner">
								<nav className="primary-nav">
									<div className="clearfix nav-wrapper">
										<a href="#home" data-section="#home" className="left brand-logo smooth-scroll">
											<LogoSvg scale={.45}/>
										</a>
										<a data-activates="mobile-demo" className="button-collapse">
											<i className="mdi mdi-menu"/>
										</a>
										<ul className="right static-menu">
											<SearchForm/>
											<li>
												<a href="#!" data-activates="dropdownmenu"
												   className="dropdown-button submenu-init">
													<i className="mdi mdi-dots-vertical right"/>
												</a>
												<ul id="dropdownmenu"
													className="inline-menu submenu-ul dropdown-content">
													{languages.map(language => (
														<li key={language.lang}>
															{(language.lang === currentLanguage ? translate(language.label) : (
																<a onClick={() => setActiveLanguage(language.lang)}>{translate(language.label)}</a>))}
														</li>
													))}
												</ul>
											</li>
										</ul>
										<StickyMenu translate={translate} {...props} />
									</div>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</header>
		);
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js